// extracted by mini-css-extract-plugin
module.exports = {"errorPage":"error-page_errorPage__39mUs","brand-welcome":"error-page_brand-welcome__3Zq1F","brand-description":"error-page_brand-description__1dBs1"};